var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repair"},_vm._l((_vm.textData),function(item){return _c('div',{staticClass:"repair3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }